<script setup>
import { defineEmits, defineProps } from 'vue';

const props = defineProps({
  column: {
    type: String,
    required: true,
  },
  sortColumn: {
    type: String,
    required: true,
  },
  sortDirection: {
    type: String,
    required: true,
  },
  width: {
    type: String,
    required: true,
  }
});

const emit = defineEmits(['sort']);

const emitSort = () => {
  emit('sort', props.column);
};
</script>

<template>
  <div
    :style="'width: ' + width +'rem;'"
    :class="[
      'cursor-pointer bg-metal-800 text-metal-300 py-2 text-center border-b border-t',
      sortColumn !== column ? 'border-b-metal-800 border-t-metal-800' : '',
      sortColumn === column && sortDirection === 'asc' ? 'border-b-metal-400 border-t-metal-800' : '',
      sortColumn === column && sortDirection === 'desc' ? 'border-t-metal-400 border-b-metal-800' : ''
    ]"
    @click="emitSort"
  >
    <slot></slot>
  </div>
</template>
